module.exports = __webpack_public_path__ + "img/Aura_smoke.d978da07.png";